import styled from 'styled-components';

const Input =styled.input`font-family: 'Quicksand', sans-serif;
font-size: 12px;
padding: 10px;
background: papayawhip;
border: none;
display: flex;
flex-direction: column;
align-content: center;
background-color: white;
border: black 1px solid;
width: 15rem;
margin: 8px;
border-radius: 5px;
color:black;
`

export default Input;